import React from 'react';
import { RadioCards, Flex, Text, TextField, SegmentedControl, Spinner } from '@radix-ui/themes';
import { Checkbox } from 'primereact/checkbox';
import { useStore } from '../../store/store';
import avatar from '../../assets/avatar.png';

export const Details = ({ logline, tone, setTone, dialogue, setDialogue, innerMonologue, setInnerMonologue, setTitle}) => {
    const [state, actions] = useStore();
    
    return (
        <div>
            <h1 style={{fontFamily: 'Poppins'}}>Novel Details & Settings</h1>

            {state.novels.length === 0 ?
                <Flex className="tutorial-container" style={{}}>
                    <Flex className={"tutorial-text"}>
                        <img src={avatar} alt="Avatar" className="tutorial-avatar" />
                        <div>
                            Now enter some details about the novel. You can always change this later as well, so don't overthink it!
                        </div>
                    </Flex>
                </Flex> : null}

            <div>
                <Text as='div' className='details-label'>Logline</Text>
                <Text as="div" className='details-logline'>{logline}</Text>
            </div>
            <br />
            <Flex justify={'between'}>
                <div style={{width: '48%'}}>
                    <Text as='div' className='details-label'>Title</Text>
                    <TextField.Root 
                        placeholder="e.g. 'Tales from the Lost City'" 
                        onChange={(e) => {setTitle(e.target.value)}}
                        variant='soft'
                    />
                </div>
                <div style={{width: '48%'}}>
                    <Text as='div' className='details-label'>Tone & Style</Text>
                    <TextField.Root 
                        placeholder="e.g. 'Dark & Gritty, but with lighthearted moments'" 
                        onChange={(e) => {setTone(e.target.value)}}
                        variant='soft'
                    />
                </div>
            </Flex>
            <br />
            <Flex style={{marginTop: '5px'}} gap={"50px"}>
                <Flex direction="column" gap="10px">
                    <SegmentedControl.Root defaultValue="yes" radius="large" value={innerMonologue} onValueChange={(e) => setInnerMonologue(e)}>
                        <SegmentedControl.Item value="no">No</SegmentedControl.Item>
                        <SegmentedControl.Item value="yes">Yes</SegmentedControl.Item>
                    </SegmentedControl.Root>
                    <label htmlFor={'innerMono'} className="ml-2">Inner Monologue</label>
                </Flex>
                <Flex direction="column" gap="10px">
                    <SegmentedControl.Root defaultValue="normal" radius="large" value={dialogue} onValueChange={(e) => setDialogue(e)}>
                        <SegmentedControl.Item value="rarely">Rarely</SegmentedControl.Item>
                        <SegmentedControl.Item value="normal">Normal</SegmentedControl.Item>
                        <SegmentedControl.Item value="a lot">A Lot</SegmentedControl.Item>
                    </SegmentedControl.Root>
                    <label htmlFor={'innerMono'} className="ml-2">Direct Speech</label>
                </Flex>
            </Flex>
            <br />
        </div>
    );
};

export default Details;